import React from 'react';
import { Route } from 'react-router-dom';
import Home from '../pages/Home';
// Membres
import AllMembres from '../pages/membres/AllMembres';
import AddCourtier from '../pages/membres/courtiers/AddCourtier';
import Courtiers from '../pages/membres/courtiers/Courtiers';
import DetailsCourtier from '../pages/membres/courtiers/DetailsCourtier';
import DetailsAgence from '../pages/membres/DetailsAgence';
import DetailsIntermediaire from '../pages/membres/DetailsIntermediaire';
import DetailsMembre from '../pages/membres/DetailsMembre';
import Intermediaires from '../pages/membres/intermediaires/Intermediaires';
import NouvelleConventionCollaboration from '../pages/membres/courtiers/NouvelleConventionCollaboration';
// Opérations
import Cession from '../pages/operations/cessions/Cession';
import CessionsPool from '../pages/operations/cessions/CessionsPool';
import Retrocession from '../pages/operations/retrocesions/Retrocession';
import Retrocessions from '../pages/operations/retrocesions/Retrocessions';
import RetrocessionDocuments from '../pages/operations/retrocesions/RetrocessionDocuments';
import ArretesVT from '../pages/operations/retrocesions-vt/ArretesVT';
import ArreteVTDetail from '../pages/operations/retrocesions-vt/ArreteVTDetail';
import VersementsVT from '../pages/operations/retrocesions-vt/VersementsVT';
// Stats
import EtatsProductionGlobal from '../pages/stats/production/EtatsProductionGlobal';
import DashboardProduction from '../pages/stats/analytics/production/DashboardProduction';
import EtatsSinistres from '../pages/stats/sinistre/EtatsSinistres';
import EtatsSinistresModerne from '../pages/stats/sinistre/EtatsSinistresModerne';
import StatistiquesSAP from '../pages/stats/sinistre/sap/StatistiquesSAP';
import StatistiquesProduction from '../pages/stats/production/agency-production/StatistiquesProduction';
// Admin / Droits
import AddHabilitation from '../pages/accessandrights/AddHabilitation';
import AddProfil from '../pages/accessandrights/AddProfil';
import Habilitations from '../pages/accessandrights/Habilitations';
import Modules from '../pages/accessandrights/Modules';
import Profils from '../pages/accessandrights/Profils';
import AllRoutes from '../pages/accessandrights/AllRoutes';
import Utilisateurs from '../pages/utilisateurs/Utilisateurs';
import AddUtilisateur from '../pages/utilisateurs/AddUtilisateur';
import DetailsUtilisateur from '../pages/utilisateurs/DetailsUtilisateur';
import RequireRights from '../components/services/RequireRights';
// Compte
import Profile from '../pages/account/Profile';
import ProfileNotifications from '../pages/account/ProfileNotifications';
import ProfileSecurity from '../pages/account/ProfileSecurity';
// Comptabilité
import Balance from '../pages/comptabilite/Balance';
import Comptes from '../pages/comptabilite/Comptes';
import GrandLivre from '../pages/comptabilite/GrandLivre';
import Parametrage from '../pages/comptabilite/Parametrage';
// Migration
import MigrationDeclarationSinistre from '../pages/migration/MigrationDeclarationSinistre';
import MigrationSinistrePayes from '../pages/migration/MigrationSinistrePayes';
import MigrationProduction from '../pages/migration/MigrationProduction';
import MigrationProvisionsEtatsDossiers from '../pages/migration/MigrationProvisionsEtatsDossiers';
import ReprisePolicesEforce from '../pages/migration/ReprisePolicesEforce';
import RepriseSinistresDecl from '../pages/migration/RepriseSinistresDecl';
import RepriseSinistresPaie from '../pages/migration/RepriseSinistresPaie';
import RepriseGumVt from '../pages/migration/RepriseGumVt';
import RepriseGumVtReglements from '../pages/migration/RepriseGumVtReglements';
import RepriseGumVtCommissariats from '../pages/migration/RepriseGumVtCommissariats';
import RepriseGumVtSapEval from '../pages/migration/RepriseGumVtSapEval';
import RepriseGumVtHonoraires from '../pages/migration/RepriseGumVtHonoraires';
import RepriseGumVtEvalCourante from '../pages/migration/RepriseGumVtEvalCourante';
import RepriseGumVtDates from '../pages/migration/RepriseGumVtDates';
import RepriseSinistreFusion from '../pages/migration/RepriseSinistreFusion';
// Divers
import VideoTutorialsPage from '../pages/documentation/VideoTutorialsPage';
import LogsViewer from '../pages/logs/LogsViewer';
import UserLogging from '../pages/logs/UserLogging';
import Logs from '../pages/logs/Logs';
import BulkEmailSender from '../pages/mailing/BulkEmailSender';
import GestionPaiementSinistreEntitesConstat from '../pages/sinistres/GestionPaiementSinistreEntitesConstat';

const OtherRoutes = () => (
    <>
        <Route path="/" index element={<Home />} />

        {/* Membres & Partenaires */}
        <Route path="/membres" element={<AllMembres />} />
        <Route path="/membre/:organismeCode" element={<DetailsMembre />} />
        <Route path="/ma-compagnie" element={<DetailsMembre />} />
        <Route path="/courtiers" element={<Courtiers />} />
        <Route path="/ajouter-courtier" element={<AddCourtier />} />
        <Route path="/courtier/:courtierId" element={<DetailsCourtier />} />
        <Route path="/intermediaires" element={<Intermediaires />} />
        <Route path="/intermediaire/:codeIntermediaire" element={<DetailsIntermediaire />} />
        <Route path="/mon-agence" element={<DetailsAgence />} />
        <Route path="/agence" element={<DetailsAgence />} />
        <Route path="/agence/:codeAgence" element={<DetailsAgence />} />
        <Route path="/soumettre-une-convention-de-collaboration" element={<NouvelleConventionCollaboration />} />

        {/* Opérations */}
        <Route path="/cession" element={<Cession />} />
        <Route path="/toutes-les-cessions" element={<CessionsPool />} />
        <Route path="/retrocession" element={<Retrocession />} />
        <Route path="/retrocessions" element={<Retrocessions />} />
        <Route path="/retrocessions-documents" element={<RetrocessionDocuments />} />
        <Route path="/retrocession-vt/arretes" element={<ArretesVT />} />
        <Route path="/retrocession-vt/arrete/:arreteId" element={<ArreteVTDetail />} />
        <Route path="/retrocession-vt/versements" element={<VersementsVT />} />

        {/* Statistiques */}
        <Route path="/etats/production-globale" element={<EtatsProductionGlobal />} />
        <Route path="/stats/production-globale" element={<DashboardProduction />} />
        <Route path="/etats/sinistres" element={<EtatsSinistres />} />
        <Route path="/stats/sinistres" element={<EtatsSinistresModerne />} />
        <Route path="/stats/sap-sinistres" element={<StatistiquesSAP />} />
        <Route path="/stats/agence-prod" element={<StatistiquesProduction />} />

        {/* Administration */}
        <Route element={<RequireRights codeHabilitation={"HPE033"} />}>
            <Route path="/utilisateurs" element={<Utilisateurs />} />
            <Route path="/ajouter-utilisateur" element={<AddUtilisateur />} />
            <Route path="/details-utilisateur/:utilisateurId" element={<DetailsUtilisateur />} />
            <Route path="/ajouter-utilisateur-agence/:codeAgence" element={<AddUtilisateur />} />
        </Route>
        <Route path="/profils" element={<Profils />} />
        <Route path="/modifier-profil/:profilId" element={<AddProfil />} />
        <Route path="/ajouter-profil" element={<AddProfil />} />
        <Route path="/ajouter-habilitation" element={<AddHabilitation />} />
        <Route path="/habilitations" element={<Habilitations />} />
        <Route path="/modules" element={<Modules />} />
        <Route path="/routes" element={<AllRoutes />} />

        {/* Compte */}
        <Route path="/mon-profil" element={<Profile />} />
        <Route path="/mon-profil-securite" element={<ProfileSecurity />} />
        <Route path="/mon-profil-notifications" element={<ProfileNotifications />} />

        {/* Comptabilité */}
        <Route path="/comptabilite/grand-livre" element={<GrandLivre />} />
        <Route path="/comptabilite/balance" element={<Balance />} />
        <Route path="/comptabilite/comptes" element={<Comptes />} />
        <Route path="/comptabilite/parametrage" element={<Parametrage />} />

        {/* Migration */}
        <Route path="/migration/production" element={<MigrationProduction />} />
        <Route path="/migration/sinistres/declarations" element={<MigrationDeclarationSinistre />} />
        <Route path="/migration/sinistres/payes" element={<MigrationSinistrePayes />} />
        <Route path="/migration/sinistres/provisions-etats" element={<MigrationProvisionsEtatsDossiers />} />
        <Route path="/migration/reprise/polices-eforce" element={<ReprisePolicesEforce />} />
        <Route path="/migration/reprise/sinistres-declarations" element={<RepriseSinistresDecl />} />
        <Route path="/migration/reprise/sinistres-payes" element={<RepriseSinistresPaie />} />
        <Route path="/migration/reprise/gumvt" element={<RepriseGumVt />} />
        <Route path="/migration/reprise/gumvt-reglements" element={<RepriseGumVtReglements />} />
        <Route path="/migration/reprise/gumvt-commissariats" element={<RepriseGumVtCommissariats />} />
        <Route path="/migration/reprise/gumvt-sap-evaluations" element={<RepriseGumVtSapEval />} />
        <Route path="/migration/reprise/gumvt-honoraires" element={<RepriseGumVtHonoraires />} />
        <Route path="/migration/reprise/gumvt-evaluation-courante" element={<RepriseGumVtEvalCourante />} />
        <Route path="/migration/reprise/gumvt-dates" element={<RepriseGumVtDates />} />
        <Route path="/migration/reprise/sinistres-fusion-doublons" element={<RepriseSinistreFusion />} />

        {/* Divers */}
        <Route path="/video-tutorials" element={<VideoTutorialsPage />} />
        <Route path="/logs" element={<LogsViewer />} />
        <Route path="/logs-users" element={<UserLogging />} />
        <Route path="/activity-logs" element={<Logs />} />
        <Route path="/email/bulk" element={<BulkEmailSender />} />
        <Route path="/paiements-sinistre-entites" element={<GestionPaiementSinistreEntitesConstat />} />
    </>
);

export default OtherRoutes;
